// pdfjsLoader.js -- NFI-5884: load pdf.js on first use only (its own chunk), with its in-page worker: no CDN, no extra file in
// public/. pdfjs-dist 4.10.38 (CVE-2024-4367 is fixed from 4.2.67); documents are still opened with isEvalSupported: false.
// Kept in its own module so tests can replace it.

let pdfjsPromise = null;

export function getPdfjs() {
  if (!pdfjsPromise) {
    pdfjsPromise = Promise.all([import('pdfjs-dist/legacy/build/pdf.mjs'), import('pdfjs-dist/legacy/build/pdf.worker.mjs')])
      .then(([lib, worker]) => {
        // pdf.js looks for globalThis.pdfjsWorker (window, in a browser) before it tries to start a separate worker.
        // window, not globalThis: CRA's lint rejects globalThis (no-undef).
        window.pdfjsWorker = worker && worker.WorkerMessageHandler ? worker : worker.default;
        return lib && lib.getDocument ? lib : lib.default;
      });
    pdfjsPromise.catch(() => { pdfjsPromise = null; });
  }
  return pdfjsPromise;
}

// One plain GET for the whole file: no byte-range requests, so the documents bucket needs no CORS preflight rule (only GET from
// the app's origin). The panel reads every page anyway, so ranges would save nothing.
export const OPEN_OPTIONS = { isEvalSupported: false, disableRange: true, disableStream: true, disableAutoFetch: true };
